let stack

try {
  stack = require("../../stack.json")
} catch(error) {
  console.warn("Stack not created yet. Create it by running `sls deploy`")
  stack = {}
}

const config = {
  Auth: {
    mandatorySignIn: true,
    region: stack.Region,
    userPoolId: stack.UserPoolId,
    identityPoolId: stack.IdentityPoolId,
    userPoolWebClientId: stack.UserPoolClientId,
  },
  aws_appsync_apiKey: stack.GraphQlApiKeyDefault,
  aws_appsync_graphqlEndpoint: stack.GraphQlApiUrl,
  aws_appsync_region: stack.Region,
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  oauth: {
    domain: `${stack.OAuthDomainPrefix}.auth.eu-west-1.amazoncognito.com`,
    scope : ["phone", "email", "profile", "openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: stack.OAuthCallbackUrl,
    redirectSignOut: stack.OAuthLogoutUrl,
    responseType: "token"
  }
}

export default config
